import CarruselDeMentores from "@/components/portada/CarruselDeMentores";

/** QUIÉN TE ACOMPAÑA — Sócrates y un mentor por competencia.
 *
 * DÓNDE VIVE Y POR QUÉ. Nació dentro de `FilaBlanca.jsx`, compartiendo fila con el profesor y
 * «Para tu clase». El 3 de noviembre de 2026 sube a la fila del catálogo, a la derecha de
 * «Para tu curso»: quien acaba de mirar si hay algo de lo suyo tiene al lado con quién lo
 * estudiaría, y las dos tarjetas de abajo se quedan con su barra entera.
 *
 * Y NO OCUPA LA BARRA ENTERA NUNCA. El carrusel se pinta DOS VECES para dar la vuelta sin
 * costura, así que en cuanto el carril es más ancho que una tanda se ven dos Sócrates a la
 * vez. Pasó. En cinco columnas caben tres caras y la segunda tanda queda fuera de la vista.
 *
 * LOS PÁRRAFOS DE CADA MENTOR SE FUERON el 19 de octubre de 2026 —*«los párrafos de mentor
 * ahora indican asignaturas. se van»*—: decían la materia, que es la palabra que esta casa
 * retiró de cara al alumno. Queda la cara y la competencia, que es lo único que hace falta
 * saber aquí; lo demás está a un clic, en la página de su competencia.
 *
 * Y EL PÁRRAFO DE LA TARJETA SE FUE EL 3 DE NOVIEMBRE, por una razón de fila y no de texto:
 * esta tarjeta y la del catálogo comparten altura, y aquí sobraban tres renglones que allí
 * no existen. Decía que los mentores no son asignaturas con nombre de persona; lo mismo lo
 * dice ya el pie de cada cara, que pone la competencia debajo del nombre.
 */
export default function QuienTeAcompana() {
  return (
    <div className="rounded-ficha bg-white p-6 sm:p-8 h-full" data-testid="landing-mentores">
      <div className="font-mono-alpha text-[10px] uppercase tracking-[0.22em] text-alpha-red">
        Quién te acompaña
      </div>
      <h2 className="font-serif-display text-[30px] sm:text-[34px] leading-[1.08] mt-2">
        Sócrates, y un mentor por competencia.
      </h2>
      <CarruselDeMentores />
    </div>
  );
}
